import {
  Alert,
  Button,
  Card,
  Col,
  Descriptions,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Tag,
  notification,
} from "antd";
import { useEffect, useState } from "react";
import commitPendingInput from "../../utils/commitPendingInput";
import useApi from "../../utils/useApi";
import { describeError } from "./status";

function hostDaUrl(url) {
  try {
    return new URL(url).host;
  } catch {
    return url || "-";
  }
}

function EnvioModal({ aberto, config, onFechar, onSalvo }) {
  const { updateAiReportDelivery } = useApi();
  const [form] = Form.useForm();
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (!aberto || !config) return;
    form.setFieldsValue({
      webhook_url: config.webhook_url,
      webhook_user: config.webhook_user,
      webhook_setor: config.webhook_setor,
      intervalo_entre_envios: config.intervalo_entre_envios,
      webhook_pass: "",
      webhook_secret: "",
    });
  }, [aberto, config]);

  const salvar = async () => {
    await commitPendingInput();
    let valores;
    try {
      valores = await form.validateFields();
    } catch {
      return;
    }
    const corpo = { ...valores };
    if (!corpo.webhook_pass) delete corpo.webhook_pass;
    if (!corpo.webhook_secret) delete corpo.webhook_secret;
    setSalvando(true);
    try {
      onSalvo(await updateAiReportDelivery(corpo));
      notification.success({ message: "Envio por WhatsApp salvo." });
      onFechar();
    } catch (err) {
      notification.error({
        message: "Erro ao salvar o envio por WhatsApp.",
        description: describeError(err, "Verifique os campos."),
      });
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Modal
      open={aberto}
      title="Envio por WhatsApp"
      okText="Salvar"
      cancelText="Cancelar"
      confirmLoading={salvando}
      onOk={salvar}
      onCancel={onFechar}
      width={640}
      destroyOnClose>
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item
          name="webhook_url"
          label="URL do webhook"
          rules={[
            {
              pattern: /^https:\/\//,
              message: "Use https://: a senha trafega em claro em http.",
            },
          ]}>
          <Input placeholder="https://webhook.exemplo.com/webhook/uuid" />
        </Form.Item>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item name="webhook_user" label="Usuário">
              <Input autoComplete="off" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="webhook_setor" label="Setor">
              <Input placeholder="ouran_semanal" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="webhook_pass"
              label="Senha"
              extra={
                config?.webhook_pass_configurado
                  ? "Senha salva. Deixe em branco para manter."
                  : "Nenhuma senha salva."
              }>
              <Input.Password autoComplete="new-password" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="webhook_secret"
              label="x-app-secret"
              extra={
                config?.webhook_secret_configurado
                  ? "Segredo salvo. Deixe em branco para manter."
                  : "Nenhum segredo salvo."
              }>
              <Input.Password autoComplete="new-password" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          name="intervalo_entre_envios"
          label="Intervalo entre mensagens (segundos)"
          extra="Espera entre uma mensagem e a seguinte, somando todas as rotinas. Mensagens em rajada podem levar o WhatsApp a bloquear o número. 0 = sem espera."
          rules={[{ required: true, message: "Informe o intervalo." }]}>
          <InputNumber min={0} max={3600} style={{ width: 200 }} />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default function EnvioCard({ habilitado, onMudou }) {
  const { getAiReportDelivery } = useApi();
  const [config, setConfig] = useState(null);
  const [aberto, setAberto] = useState(false);

  useEffect(() => {
    getAiReportDelivery()
      .then(setConfig)
      .catch(() => setConfig(null));
  }, []);

  return (
    <Card
      title="Envio por WhatsApp"
      extra={
        <Button onClick={() => setAberto(true)} disabled={!config}>
          Configurar
        </Button>
      }>
      {!habilitado && (
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 12 }}
          message="O envio está desligado neste ambiente (AI_REPORTS_DELIVERY_ENABLED). Nada sai por WhatsApp, mesmo configurado."
        />
      )}
      {config && !config.webhook_configurado && (
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 12 }}
          message="Falta configurar URL, usuário, senha e segredo. Sem eles nenhuma rotina envia."
        />
      )}
      <Descriptions size="small" column={{ xs: 1, sm: 2, lg: 4 }}>
        <Descriptions.Item label="Situação">
          {config?.webhook_configurado ? (
            <Tag color="success">Pronto para enviar</Tag>
          ) : (
            <Tag color="warning">Incompleto</Tag>
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Webhook">
          {hostDaUrl(config?.webhook_url)}
        </Descriptions.Item>
        <Descriptions.Item label="Setor">
          {config?.webhook_setor || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Intervalo entre mensagens">
          {config ? `${config.intervalo_entre_envios} s` : "-"}
        </Descriptions.Item>
      </Descriptions>
      <EnvioModal
        aberto={aberto}
        config={config}
        onFechar={() => setAberto(false)}
        onSalvo={(novo) => {
          setConfig(novo);
          if (onMudou) onMudou();
        }}
      />
    </Card>
  );
}
